import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';
import i18n from "shared/i18n";

import { connect } from 'react-redux';
import { patchUser, clearPatchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';

import './SensitiveMaterialForm.css';

class SensitiveMaterialForm extends Component {
  static propTypes = {
    patchUser: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    patchUserSuccess: PropTypes.object,
    patchUserError: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    patchUserSuccess: null,
    patchUserError: null,
    me: null,
  };

  state = {
    currentValue: null,
  };

  componentDidMount() {
    this.setState({ currentValue: this.props.me.sensitive_content });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentValue !== this.state.currentValue && this.state.currentValue !== this.props.me.sensitive_content) {
      this.changeSensitiveContent(this.state.currentValue);
    }
  }

  changeSensitiveContent = value => {
    const form = new FormData();
    form.append('sensitive_content', value);
    this.props.patchUser(form);
  };

  onChangeSensitiveMode = () => {
    if (this.props.me.sensitive_content !== 'off') {
      this.setState({ currentValue: 'off' });
    } else {
      this.setState({ currentValue: 'sensitive' });
    }
  };

  render() {
    const { me } = this.props;
    const { currentValue } = this.state;
    if (!me || (me && !me.sensitive_content)) {
      return null;
    }

    const options = [
      {
        label: '12+',
        value: '12',
      },
      {
        label: '15+',
        value: '15',
      },
      {
        label: '18+',
        value: '18',
      },
      {
        label: '21+',
        value: '21',
      },
      {
        label: '25+',
        value: '25',
      },
      {
        label: i18n.t("Sensitive Content"),
        value: 'sensitive',
      },
    ];

    return (
      <Translation>
        {(t) => (
          <div className="sensitive-material-form__component">
            {/* Header */}
            <div className="header-container">
              <div className="header">
                <div className="header-text">{t("Sensitive Material")}</div>
                <div className="undertext">
                  {t("Visitors to your HeyLink.me will see a Sensitive Content warning before being able to view your profile.")}
                </div>
              </div>
              <div className="sensitive-checkbox">
                <div className="label">{t("OFF")}</div>
                <Checkbox
                  toggle
                  checked={currentValue !== 'off'}
                  onChange={this.onChangeSensitiveMode}
                />
                <div className="label">{t("ON")}</div>
              </div>
            </div>

            {/* Sensitive Options */}
            {currentValue !== 'off' &&
              <div className="sensitive-options">
                <div className="label">{t("Please Select One:")}</div>
                <div className="options-container">
                  {options.map(option => (
                    <div
                      className="option"
                      onClick={() => {
                        this.setState({ currentValue: option.value });
                      }}
                      role="button"
                      tabIndex={-1}
                    >
                      <div className="checkbox-container">
                        <Checkbox
                          radio
                          checked={currentValue === option.value}
                        />
                      </div>
                      <div
                        className={`option-label${currentValue === option.value ? ' active' : ''}`}
                      >
                        {option.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
    clearPatchUser,
  },
)(SensitiveMaterialForm);
